<template>
  <div>
    <el-form
      :model="form"
      label-width="80px"
      :inline="true"
      class="demo-form-inline"
      id="form"
    >
      <el-row :gutter="gutter">
        <el-col :span="22">
          <el-col :span="4" class="label"> 角色名称： </el-col>
          <el-col :span="20">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="22">
          <el-col :span="4" class="label"> 备注： </el-col>
          <el-col :span="20">
            <el-input v-model="form.remark"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="22">
          <el-col :span="4" class="label"> 角色权限： </el-col>
          <el-col :span="20">
            <el-transfer
              class="jsqx"
              v-model="form.permission_id"
              :data="permission"
              :titles="['所有权限', '已选权限']"
            >
            </el-transfer>
          </el-col>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 0">
        <el-col :span="5" :offset="8">
          <el-button type="primary" @click="sub()"> 确定 </el-button>
        </el-col>
        <el-col :span="5" :offset="3">
          <el-button type="primary" @click="close()"> 取消 </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "role",
  props: ["layerid", "isedit", "per"],
  data() {
    return {
      gutter: 20,
      form: {
        name: "",
        remark: "",
        permission_id: [],
      },
      options: [],
      value: [],
      permission: [],
      states: [
        { state: "1", label: "待审核" },
        { state: "6", label: "已审核(待预约)" },
        { state: "4", label: "待会诊" },
        { state: "5", label: "已完成" },
        { state: "2", label: "未通过" },
        { state: "7", label: "已退回" },
        { state: "8", label: "已取消" },
      ],
      can_operat: [],
    };
  },
  mounted() {
    this.setPermission(this.per);
    if (this.isedit) {
      this.form.id = this.isedit.id;
      this.form.name = this.isedit.name;
      this.form.remark = this.isedit.remark;
      console.log("数据1",this.isedit.auth_permissions)
      console.log(this.isedit);
      // this.form.can_operat = this.isedit.can_operat.split(",");
      // this.can_operat = this.isedit.can_operat.split(",");
      let permission_id = [];
      for (let i = 0; i < this.isedit.auth_permissions.length; ++i) {
        permission_id.push(this.isedit.auth_permissions[i].id);
      }
      this.form.permission_id = permission_id;
    }
  },
  methods: {
    setPermission(data) {
      let all = [];
      data.forEach(item=>{
        all.push({
          key:item.id,
          label:item.name
        })
      })
      this.permission = all;
    },
    sub() {
      let obj = {
        states: false,
      };
      if (this.form.name != "" && this.form.permission_id.length != 0) {
        obj.form = this.form;
        this.$emit("roleEmit", obj);
      }
      else{
        this.$message.error("名称与权限为必填项")
      }
      this.form = {};
    },
    close() {
      let obj = {
        states: false,
      };
      this.$emit("roleEmit", obj);
      this.form = {};
    },
  },
};
</script>

<style scoped lang="scss">
#form {
  .el-col {
    min-height: 40px;
    .el-date-editor {
      width: 100%;
    }
    .label {
      color: #5f6165;
      height: 40px;
      line-height: 38px;
      text-align: right;
      font-size: 14px;
    }
    .el-radio-group {
      margin-top: 14px;
      float: left;
    }
    .ty {
      text-align: left;
      border-radius: 5px;
      background-color: #e2b837;
      height: 50px;
      line-height: 3.5;
    }
  }
  .el-row {
    min-height: 30px;
    margin-bottom: 22px;
  }
  .el-select {
    width: 100%;
  }
}
</style>
<style lang="scss">
.jsqx {
  .el-transfer-panel {
    width: 315px;
  }
  .el-transfer-panel__body label {
    width: 100%;
  }
}
</style>